import { render, staticRenderFns } from "./PendingFileModal.vue?vue&type=template&id=6700e895"
import script from "./PendingFileModal.vue?vue&type=script&lang=js"
export * from "./PendingFileModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports